module.exports = __webpack_public_path__ + "img/prize.5d9c7a60.png";